import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useCancelIndividualItem = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({
      orderItemId,
      reason,
      fairId,
    }: {
      orderItemId: number;
      reason?: string;
      fairId: number;
    }) => {
      return fetch(`${API}/api/order-item/cancel-individual`, {
        method: "POST",
        body: {
          order_item_id: orderItemId,
          reason: reason || "Item não entregue pelo agricultor",
        },
      });
    },
    onMutate: async ({
      fairId,
      orderItemId,
    }: {
      fairId: number;
      orderItemId: number;
    }) => {
      await queryClient.cancelQueries({ queryKey: ["orders", fairId] });

      const previousOrders = queryClient.getQueryData(["orders", fairId]);

      queryClient.setQueryData(["orders", fairId], (oldOrders: any) => {
        return oldOrders.map((order: any) => ({
          ...order,
          items: order.items.map((item: any) =>
            item.id === orderItemId
              ? {
                  ...item,
                  is_canceled: true,
                  canceled_at: new Date().toISOString(),
                  canceled_reason: "Item não entregue pelo agricultor",
                }
              : item,
          ),
        }));
      });

      return { previousOrders };
    },
    onError: (err, newTodo, context) => {
      queryClient.setQueryData(["orders"], context?.previousOrders);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

const useUncancelIndividualItem = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({
      orderItemId,
      fairId,
    }: {
      orderItemId: number;
      fairId: number;
    }) => {
      return fetch(`${API}/api/order-item/uncancel-individual`, {
        method: "POST",
        body: {
          order_item_id: orderItemId,
        },
      });
    },
    onMutate: async ({
      fairId,
      orderItemId,
    }: {
      fairId: number;
      orderItemId: number;
    }) => {
      await queryClient.cancelQueries({ queryKey: ["orders", fairId] });

      const previousOrders = queryClient.getQueryData(["orders", fairId]);

      queryClient.setQueryData(["orders", fairId], (oldOrders: any) => {
        return oldOrders.map((order: any) => ({
          ...order,
          items: order.items.map((item: any) =>
            item.id === orderItemId
              ? {
                  ...item,
                  is_canceled: false,
                  canceled_at: null,
                  canceled_reason: "",
                  canceled_by: null,
                }
              : item,
          ),
        }));
      });

      return { previousOrders };
    },
    onError: (err, newTodo, context) => {
      queryClient.setQueryData(["orders"], context?.previousOrders);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["orders"] });
    },
  });
};

export { useCancelIndividualItem, useUncancelIndividualItem };
export default useCancelIndividualItem;
